import { render } from "./ParticipantItemRow.vue?vue&type=template&id=450a5b1e&ts=true"
import script from "./ParticipantItemRow.vue?vue&type=script&lang=ts"
export * from "./ParticipantItemRow.vue?vue&type=script&lang=ts"

import "./ParticipantItemRow.vue?vue&type=style&index=0&id=450a5b1e&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__